import React from 'react'
import PropTypes from 'prop-types'

import { _MainContentCol } from './styles'

const MainContent = ({ className, children }) => <_MainContentCol className={className}>{children}</_MainContentCol>

MainContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.node]),
}

export default MainContent

